import React          from 'react';
import dayjs          from '~/lib/dayjs';
import DateTimePicker from '../forms/DateTimePicker';

const StyleguideDatepicker = (props) => (
  <div className="mb15">
    <DateTimePicker
      {...props}
      pickerType="date"
      maxDate={dayjs().add(4, 'day').toDate()}
    />
  </div>
);

export default StyleguideDatepicker;
